import React, { useContext, useEffect, useState } from "react";
import {
    Accordion,
    AccordionHeader,
    AccordionBody
} from "@material-tailwind/react";
import ProcedureItem from "./ProcedureItem";
import Loading from "./Loading";
import Pager from "./Pager";

import MyProceduresContext from '../context/ProceduresContext';

const DropDownProcedureClasses = ({ title, index, handleOpen, open }) => {
    const { setPage, maxPage, procedureTypeId, procedureClassId, useProcedures } = useContext(MyProceduresContext);
    const { procedures, isError, isLoading } = useProcedures();

    const bodyStyles = {
        open: "flex flex-col animation-appear-accordion",
        close: "hidden"
    }

    const style = index === open ? {background: '#00549F', color:"white"} : {};

    return (
        <div className="lg:w-[90%] md:w-[95%] w-[100%] mx-auto rounded-lg bg-white my-4" >
            <button onClick={() => { handleOpen(index); setPage(0) }} style={style} className="flex flex-row px-8 py-3 justify-between rounded-md w-full border-b-2 hover:bg-govNavBar hover:text-white duration-700" >
                <h1 className="break-all font-light">{title}</h1>
                {index === open ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
                    : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                    </svg>
                }
            </button>
            <div className={index === open ? bodyStyles.open : bodyStyles.close} id="body">
                <div className="flex flex-wrap justify-center items-center w-full lg:px-4 lg:py-4 md:px-4 md:py-4 py-2 mx-auto break-words">
                    {isLoading ? <Loading isLoading={isLoading} /> : !isError ? procedures.length > 0 ? procedures.map((procedure, index) => (
                        <ProcedureItem key={index} procedure={procedure} />

                    )) : <h1 className='text-center w-full font-light'>No hay registros para mostrar</h1> : <h1 className='text-center text-red-500 w-full'>Ha ocurrido un error al cargar los datos.</h1>}
                </div>
                {maxPage < 1 ? null : <div className='flex justify-center mb-4'>
                    <Pager maxPage={maxPage} setPage={setPage} change1={procedureTypeId} change2={procedureClassId} />
                </div>}

            </div>
        </div>
    );
}

export default DropDownProcedureClasses;